import EventListResultModelBase from '../_generated/modelBases/event-list-result-model-base';

export default class EventListResultModel extends EventListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
